module.exports = __webpack_public_path__ + "files/ab89aabdfbdecd55f65a0ec0002ed51b.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-bold-webfont.woff
 ** module id = 1012
 ** module chunks = 0
 **/